/*
 * Horizontal row of bundle cards on the product page (snippets/product-bundles.liquid).
 * The track scrolls natively (swipe, trackpad); the arrows move it by one card and only show
 * when the cards don't fit.
 */
(() => {
  if (customElements.get('bundle-scroller')) return;

  class BundleScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroller-track]');
      this.arrows = this.querySelector('[data-scroller-arrows]');
      this.prev = this.querySelector('[data-scroller-prev]');
      this.next = this.querySelector('[data-scroller-next]');
      if (!this.track || !this.arrows) return;

      this.update = this.update.bind(this);
      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', this.update, {passive: true});
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    scrollByCard(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({left: direction * (card.offsetWidth + gap), behavior: 'smooth'});
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.arrows.hidden = max <= 1;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  customElements.define('bundle-scroller', BundleScroller);
})();
